import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=0cbb08ce&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=0cbb08ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb08ce",
  null
  
)

export default component.exports